import 'leaflet.markercluster/dist/MarkerCluster.Default.css'
import 'leaflet.markercluster/dist/MarkerCluster.css'

import leaflet_cluster from 'leaflet.markercluster'

export default leaflet_cluster
